import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiBell } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { notificationAPI } from '../../services/api';

const NotificationBadge = ({ to, className, iconClassName, children }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    fetchCount();
    // Poll every minute
    const interval = setInterval(fetchCount, 60000);
    return () => clearInterval(interval);
  }, []);

  const fetchCount = async () => {
    try {
      const { data } = await notificationAPI.getUnreadCount();
      setCount(data.count);
    } catch (error) {
      console.error('Failed to fetch notification count');
    }
  };

  const defaultClassName = "relative p-2 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500";

  return (
    <Link to={to} className={className || defaultClassName}>
      <span className="sr-only">View notifications</span>
      <div className="relative inline-block">
        <SafeIcon icon={FiBell} className={iconClassName || "h-6 w-6"} />
        {count > 0 && (
          <span className="absolute -top-1 -right-1 block h-4 w-4 rounded-full ring-2 ring-white bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">
            {count > 99 ? '99+' : count}
          </span>
        )}
      </div>
      {children}
    </Link>
  );
};

export default NotificationBadge;
